<template>
  <el-popover placement="bottom" width="250" trigger="click" :offset="40">
    <el-table-wrapper :data="tableData" :columns="tableColumns" :column-default="columnDefault" :max-height="250" :pagination="false"></el-table-wrapper>
    <span slot="reference"><i class="fas fa-info-circle" style="cursor: pointer"></i></span>
  </el-popover>
</template>

<script>
import { columnDefault } from '@/constants/table';
import BasicinfoSubAPI from '@/api/model/basicinfo-sub';
import msgUtil from '@/utils/message';

export default {
  name: 'WForbiddenCommandKeywordLegend',
  data() {
    return {
      columnDefault,
      tableData: [
      ],
      tableColumns: [
        {
          prop: 'basicinfoSubname',
          label: '수행 불가 명령어',
          sortable: true,
          searchable: false,
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      const target = '수행 불가 명령어';
      const action = msgUtil.action.VIEW;
      BasicinfoSubAPI.getList('EXECUTION_FORBIDDEN_COMMAND')
        .then((response) => {
          const result = response.data;
          if (result.success) {
            this.tableData = result.data;
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, result.success));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
    },
    getForbiddenCommandList() {
      return this.tableData;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/button/ForbiddenCommandKeywordLegend.vue